



















import EventDetailsOverview from './EventDetailsOverview.vue';
import { PropType } from 'vue';
import CalendarEventInvitees from '../../../../shared/PageFragments/CalendarEvent/CalendarEventInvitees.vue';
import { parentTypes } from '../../../../shared/enums/parentTypes';
import EventDetailsAttachments from './EventDetailsAttachments.vue';
import EventDetailsContent from './EventDetailsContent.vue';
import { EventData } from '../../../business/calendar/eventData';

export default {
  components: {
    EventDetailsContent,
    EventDetailsAttachments,
    CalendarEventInvitees,
    EventDetailsOverview,
  },
  props: {
    eventData: { type: Object as PropType<EventData>, required: true },
  },
  emits: ['reminderSent', 'openAttachment'],
  computed: {
    parentTypes() {
      return parentTypes;
    },
    invitees() {
      return this.eventData.invitees ?? [];
    },
    groupHomeInvitees() {
      return this.eventData.invitedGroupHomeChildren || [];
    },
    hasInvitees() {
      return this.invitees.length + this.groupHomeInvitees.length > 0;
    },
  },
  methods: {
    emitReminderSent() {
      this.$emit('reminderSent');
    },
    emitOpenAttachment(data) {
      this.$emit('openAttachment', data);
    },
  },
};
